"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _memoryStorage = _interopRequireDefault(require("./memory-storage"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var LocalStorageService =
/*#__PURE__*/
function () {
  /**
   * Storage implementation used to persist the data
   * @type Storage
   */

  /**
   * Initialize a new storage service and call the migration callbacks
   * @param options
   */
  function LocalStorageService() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, LocalStorageService);

    _defineProperty(this, "storage", void 0);

    _defineProperty(this, "options", void 0);

    this.options = _objectSpread({
      fallbackStorage: new _memoryStorage.default()
    }, options);

    try {
      localStorage.getItem('Random item');
      this.storage = localStorage;
    } catch (e) {
      try {
        sessionStorage.getItem('Random item');
        this.storage = sessionStorage;
      } catch (e) {
        if (this.options.fallbackStorage) {
          this.storage = this.options.fallbackStorage;
        } else {
          throw new Error('LocalStorage not available and no fallback storage defined');
        }
      }
    }

    this.migrate();
  }
  /**
   * Migrate the existing localstorage data
   */


  _createClass(LocalStorageService, [{
    key: "migrate",
    value: function migrate() {
      var _this = this;

      if (this.options === null || !this.options.namespace || !this.options.migrate || !this.options.migrateItem || !this.options.version) {
        // Nothing to migrate because the service does not use namespacing
        return;
      }

      var _this$options = this.options,
          namespace = _this$options.namespace,
          version = _this$options.version,
          migrate = _this$options.migrate,
          migrateItem = _this$options.migrateItem;
      var metaKey = "@energych/sdk-storage/".concat(namespace);
      var meta = JSON.parse(this.storage.getItem(metaKey) || '{}'); // Migrate

      migrate.call(this, version, meta.version || null); // Migrate items

      if (meta.version < version) {
        var keys = this.getNamespaceKeys();
        keys.forEach(function (key) {
          var value = migrateItem.call(_this, key, version, meta.version || null);

          if (value === null) {
            _this.storage.removeItem(key);
          } else if (typeof value !== 'undefined') {
            _this.storage.setItem(key, value);
          }
        });
      }

      meta.version = version;
      meta.namespace = namespace;
      this.storage.setItem(metaKey, JSON.stringify(meta));
    }
    /**
     * Set an item in the storage
     *
     * @param key
     * @param value
     */

  }, {
    key: "set",
    value: function set(key, value) {
      this.storage.setItem(this.addNamespace(key), value);
    }
    /**
     * Return an item from the storage
     *
     * @param key
     * @param defaultValue
     * @return {any}
     */

  }, {
    key: "get",
    value: function get(key, defaultValue) {
      return this.storage.getItem(this.addNamespace(key)) || defaultValue;
    }
    /**
     * Remove an item from the storage
     *
     * @param key
     */

  }, {
    key: "remove",
    value: function remove(key) {
      this.storage.removeItem(this.addNamespace(key));
    }
    /**
     * Clear the storage
     */

  }, {
    key: "clear",
    value: function clear() {
      var _this2 = this;

      if (this.options.namespace) {
        var keys = this.getNamespaceKeys();
        keys.forEach(function (key) {
          return _this2.storage.removeItem(key);
        });
      } else {
        this.storage.clear();
      }
    }
    /**
     * Add the namespace to a key
     * @param key
     */

  }, {
    key: "addNamespace",
    value: function addNamespace(key) {
      if (!this.options || !this.options.namespace || key.startsWith(this.options.namespace)) {
        return key;
      }

      return (this.options.namespace ? "".concat(this.options.namespace, "/") : '') + key;
    }
    /**
     * Get the keys matching the current prefix
     * @param namespace
     */

  }, {
    key: "getNamespaceKeys",
    value: function getNamespaceKeys() {
      var namespace = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.namespace || '';

      if (!namespace) {
        return [];
      }

      var keys = [];

      for (var i = 0; i < this.storage.length; i++) {
        var key = this.storage.key(i);

        if (key && key.startsWith(namespace)) {
          keys.push(key);
        }
      }

      return keys;
    }
  }]);

  return LocalStorageService;
}();

exports.default = LocalStorageService;